<template>
  <div class="container">
    <div class="line"></div>
    <div class="periods-wrapper" ref="periodsWrapper">
      <ul ref="periodsUl">
        <li v-for="(item, index) in period" :key="item.id" :ref="`li${(+item.status === 1 && activityStatus <=1 ) ? 'Active' : ''}`">
          <div class="item-inner-wrapper">
             <div class="status" :class="{ active: +item.status === 1 && activityStatus <=1 }">{{ getStatusText(item) }}</div>
              <div class="period-item" :class="{ active: +item.status === 1 && activityStatus <=1}">
              <div class="period">
                <span>{{ getTitle(index) }}</span>
                <span class="unit">期</span>
              </div>
              <span class="date-range">{{ getDate(item) }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="tip">{{tip || '可重复参与多期活动 | 均可发起人气助力'}}</div>
  </div>
</template>
<script>
import { formatDate } from '@/summerCamp/utils/index'

export default {
  name: 'notRegistered',
  components: {
  },
  props: {
    period: {
      type: Array,
      default() {
        return []
      }
    },
    tip: {
      type: String
    },
    activityStatus: {
      type: Number
    }
  },
  mounted() {
    if (this.activityStatus >= 2) {
      return
    }
    if (this.$refs.liActive) {
      const elLiActive = this.$refs.liActive[0]
      this.$refs.periodsUl.scrollLeft = elLiActive.offsetLeft + elLiActive.offsetWidth / 2 - this.$refs.periodsWrapper.offsetWidth / 2
    }
  },
  methods: {
    getStatusText(item) {
      const startDate = `${formatDate(item.start_date)}`
      const statusMap = {
        0: `${startDate}开启`,
        1: '正在进行中',
        2: '已结束'
      }
      if (this.activityStatus >= 2) {
        return '已结束'
      }

      return statusMap[item.status] || ''
    },
    getTitle(index) {
      ++index
      return index < 10 ? `0${index}` : index
    },
    formatDate(dateStr, separator) {
      if (!separator) {
        separator = '-'
      }
      const dateArr = dateStr.split(separator)
      // const year = parseInt(dateArr[0])
      let month
      if (dateArr[1].indexOf('0') === 0) {
        month = parseInt(dateArr[1].substring(1))
      } else {
        month = parseInt(dateArr[1])
      }
      const day = parseInt(dateArr[2])
      return `${month}.${day}`
    },
    getDate(item) {
      return `${formatDate(item.start_date)}-${formatDate(item.end_date)}`
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  position: relative;

  .top-title {
    text-align: center;

    .title {
      height: 30px;
      line-height: 30px;
      text-align: center;
    }

    .sub-title {
      display: inline-block;
    }
  }

  .line {
    position: absolute;
    top: 24%;
    left: 50%;
    width: 72%;
    border-radius: 2.133vw 0 0 2.133vw;
    transform: translateX(-50%);
    border-top: 1px solid #ffb398;
  }

  .periods-wrapper {
    position: relative;
    box-sizing: border-box;
    width: 85%;
    padding: 10px;
    padding-top: 14px;
    margin: 0 auto;
    background: rgba(248, 216, 175, 0.37);
    border: 1px solid #fff9ef;
    // box-shadow: 0px 3px 8px 0px rgba(244, 71, 71, 0.5);
    border-radius: 21px / 2;

    ul {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;

      li {
        position: relative;
        flex: 1;
        padding-bottom: 1px;
        margin: 0 4px;
        text-align: center;

        .status {
          position: relative;
          padding-bottom: 5px;
          margin-bottom: 15px;
          font-size: 10px;
          color: #a4715b;

          &::before {
            position: absolute;
            top: 100%;
            left: 50%;
            width: 8px;
            height: 8px;
            background: #fff5db;
            border: 3px solid #ec4906;
            border-radius: 50%;
            box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.5);
            transform: translateX(-50%);
            content: ' ';
          }

          &.active {
            font-size: 10px;
            font-weight: bold;
            color: #ec4906;
          }
        }

        .period-item {
          position: relative;
          margin-top: 25px;
          font-size: 0;
          border: 1px solid #ec4906;
          border-radius: 6px;
          box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.5);

          &.active {
            background: linear-gradient(180deg, #fff3d6 0%, #fffcf8 99%);
          }

          &::before,
          &::after {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            content: ' ';
          }

          &::before {
            bottom: 100%;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 10px solid #ec4906;
          }

          &::after {
            bottom: 95%;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 10px solid #fff3d6;
          }

          .period {
            margin-top: 8px;

            > span:first-child {
              height: 21px;
              margin-right: 2px;
              font-size: 17px;
              font-weight: bold;
              font-family: DINCondensed-Bold, DINCondensed;
              line-height: 21px;
              color: #ec4906;
            }

            .unit {
              height: 14px;
              font-size: 10px;
              font-weight: 600;
              font-family: PingFangSC-Semibold, PingFang SC;
              line-height: 14px;
              color: #ec4906;
            }
          }

          .date-range {
            display: inline-block;
            min-width: 48px;
            height: 12px;
            padding: 0 12px 7px;
            font-size: 9px;
            font-weight: 600;
            font-family: PingFangSC-Semibold, PingFang SC;
            line-height: 12px;
            color: #ec4906;
          }
        }
      }
    }

    .desc {
      text-align: center;
    }
  }

  .tip {
    height: 15px;
    padding: 14px 0 28px;
    font-size: 11px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 15px;
    text-align: center;
    color: #985845;
    opacity: 0.63;
  }
}

::-webkit-scrollbar {
  /* 隐藏滚轮 */
  display: none;
}
</style>
